import { defHttp } from '/@/utils/http/axios';
import {
  TeamMessageParams,
  NewMessageParams,
  responseNotifyParamsTeam,
  responseNotifyParamsNew,
} from './model/notifyModel';

// import { getGlobalConfig } from '../../api/sys/user';

enum Api {
  TEAM = '/user/teamMessage',
  SITE = '/user/siteMessage',
}

/** 获取team 下拉框 */
export const getTeamList = () =>
  defHttp.get<undefined>({
    url: `${Api.TEAM}/getTeamList`,
  });

/** 获取TEAM 列表 */
export const getTeamMessage = (params: TeamMessageParams) =>
  defHttp.get<responseNotifyParamsTeam>({
    url: `${Api.TEAM}/findByPage`,
    params,
  });

/** 全部标记已读 */
export const markTeamAllAsRead = (params: { teamId: number }) =>
  defHttp.post<undefined>({
    url: `${Api.TEAM}/markAllAsRead`,
    params,
  });

/** 标记已读 */
export const markTeamAsRead = (messageId: number) =>
  defHttp.post<undefined>({
    url: `${Api.TEAM}/markAsRead/${messageId}`,
  });

/** 查询未读消息 */
export const getTeamUnreadMessageNum = () =>
  defHttp.get<undefined>({
    url: `${Api.TEAM}/getUnreadMessageNum`,
  });

/** 删除某个团队的全部消息 */
export const removeMessageOfTeam = (teamId: number) =>
  defHttp.post<undefined>({
    url: `${Api.TEAM}/removeMessageByTeamId/${teamId}`,
  });

/** 获取news 列表 */
export const getNewMessage = (params: NewMessageParams) =>
  defHttp.get<responseNotifyParamsNew>({
    url: `${Api.SITE}/findByPage`,
    params,
  });

/** 全部标记已读 */
export const markNewAllAsRead = () =>
  defHttp.post<undefined>({
    url: `${Api.SITE}/markAllAsRead`,
  });

/** 标记已读 */
export const markNewAsRead = (messageId: number) =>
  defHttp.post<undefined>({
    url: `${Api.SITE}/markAsRead/${messageId}`,
  });

/** 查询未读消息 */
export const getNewUnreadMessageNum = () =>
  defHttp.get<undefined>({
    url: `${Api.SITE}/getUnreadMessageNum`,
  });

/** 查询全部未读消息 */
export const getUnreadMessageStatus = () =>
  defHttp.get<undefined>(
    {
      url: `${Api.TEAM}/hasUnreadMessage`,
    },
    {
      errorMessageMode: 'none',
    },
  );
// 消息中心  websocketUrl
export const websocketUrlForNotify = () => {
  // const config = await getGlobalConfig();
  // const isChina = config.userAuth?.mobile.enabled;

  const websocketBaseUrl = window.location.origin;

  return websocketBaseUrl + '/websocket/stomp';
};
